import { ReportsService } from './../../shared/services/reports.service';
import { state, style, trigger } from '@angular/animations';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Address } from '@classes/address';
import { Client } from '@classes/client';
import { DictionaryValue } from '@classes/dictionary/dictionaryValue';
import { Order } from '@classes/order/order';
import { Pagination } from '@classes/pagination/pagination';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import { Site } from '@classes/site';
import { User } from '@classes/user/user';
import { DatatableBaseComponent } from '@components/datatable-base.component';
import { OrderStatus } from '@enums/order-status.enum';
import { OrderType } from '@enums/order-type.enum';
import { RoleName } from '@enums/role-name.enum';
import { AddressesService } from '@services/addresses.service';
import { ArticlesService } from '@services/articles.service';
import { AuthService } from '@services/auth.service';
import moment from 'moment';
import { ClientsService } from '@services/clients.service';
import { DictionaryValuesService } from '@services/dictionaryValues.service';
import { OrdersService } from '@services/orders.service';
import { SitesService } from '@services/sites.service';
import { UiService } from '@services/ui.service';
import { UsersService } from '@services/users.service';

@Component({
  selector: 'app-export-list',
  templateUrl: './export-list.component.html',
  styleUrls: ['./export-list.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' }))
    ])
  ]
})
export class ExportListComponent extends DatatableBaseComponent implements OnInit {
  @Output() clearOneFilterEvent = new EventEmitter<any>();

  orders: Order[];
  indexToRemove = null;

  // displayedColumns = ['select', 'identifier', 'type', 'startDate', 'urgency', 'sender', 'receiver', 'status', 'client', 'site', 'createdBy', 'createdOn', 'driver', 'actions'];
  displayedColumns: string[] = [];
  displayedColumnsMenuExportList: any[] = [
    { editable: false, name: 'select', selected: true, visible: false },
    { editable: true, name: 'identifier', selected: true, visible: false },
    { editable: true, name: 'startDate', selected: true, visible: false },
    { editable: true, name: 'urgency', selected: true, visible: false },
    { editable: true, name: 'sender', selected: true, visible: false },
    { editable: true, name: 'receivers', selected: true, visible: false },
    { editable: true, name: 'status', selected: true, visible: false },
    { editable: true, name: 'client', selected: true, visible: false },
    { editable: true, name: 'site', selected: true, visible: false },
    { editable: true, name: 'createdBy', selected: true, visible: false },
    { editable: true, name: 'createdOn', selected: true, visible: false },
    { editable: true, name: 'driver', selected: true, visible: false },
    { editable: true, name: 'actions', selected: true, visible: false }
  ];

  // Additional 'filter' column list
  displayedColumnFilters: string[] = [
    'identifier-filter'
  ];
  dataSource: MatTableDataSource<Order>;
  orderStatus = OrderStatus;

  // filterValue: string;
  filterValue = null;
  pagination: Pagination;
  sortValue: string;

  dispatchers: User[];
  drivers: User[];
  clients: Client[];
  sites: Site[];
  urgencies: DictionaryValue[];
  senders: Address[];
  receivers: Address[];
  users: User[];

  isLoadingFilterForm: boolean;

  globalFilter = '';

  useSubcontractorPrices = false;

  filterForm = new UntypedFormGroup({
    identifier: new UntypedFormControl(),
    status: new UntypedFormControl(16),
    dispatcher: new UntypedFormControl(),
    client: new UntypedFormControl(),
    site: new UntypedFormControl(),
    createdBy: new UntypedFormControl(),
    startDate: new UntypedFormControl(),
    // fromStartDate: new FormControl(),
    // toStartDate: new FormControl(),
    range: new UntypedFormGroup({
      fromStartDate: new UntypedFormControl(null),
      toStartDate: new UntypedFormControl(null),
    }),
    urgency: new UntypedFormControl(),
    sender: new UntypedFormControl(),
    receiver: new UntypedFormControl(),
    driver: new UntypedFormControl()
  })

  filteredValues = {
    identifier: '',
    startDate: '',
    status: '',
    dispatcher: '',
    client: '',
    site: '',
    createdBy: '',
    urgency: '',
    sender: '',
    receiver: '',
    driver: ''
  };

  isDispatcher: boolean;
  isAdmin: boolean;

  initialSelection = [];
  allowMultiSelect = true;
  selection = new SelectionModel<any>(this.allowMultiSelect, this.initialSelection);

  allStatus: any[] = [
    {
      value: 'all',
      name: 'Tous'
    },
    {
      value: 4,
      name: 'Traitée par un régulateur'
    },
    {
      value: 8,
      name: 'Acceptée par un chauffeur'
    },
    {
      value: 16,
      name: 'Terminée'
    },
    {
      value: 32,
      name: 'Annulée'
    },
    {
      value: 64,
      name: 'Modifiée'
    },
    {
      value: 128,
      name: 'En cours'
    },
    {
      value: 256,
      name: 'A réaffecter'
    }
  ];


  allTypes = [
    {
      value: 'all',
      name: 'Tous'
    },
    {
      value: 1,
      name: 'Classique'
    },
    {
      value: 2,
      name: 'Simplifiée'
    }
  ];

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private ordersSrv: OrdersService,
    private router: Router,
    private sitesSrv: SitesService,
    private clientsSrv: ClientsService,
    private dictionarySrv: DictionaryValuesService,
    private addressesSrv: AddressesService,
    private usersSrv: UsersService,
    private authSrv: AuthService,
    private articlesSrv: ArticlesService,
    private reportsSrv: ReportsService
  ) {
    super(uiSrv);
  }

  ngOnInit() {
    this.isDispatcher =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin ||
      this.authSrv.getUser().role.name === RoleName.admin_subcontractor ||
      this.authSrv.getUser().role.name === RoleName.dispatcher;

    this.isAdmin =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin ||
      this.authSrv.getUser().role.name === RoleName.admin_subcontractor;

    super.ngOnInit();
    this.checkIfColumnsInStorage();
    this.initSubscriptions();
  }

  get canShowSubcontractorToggle(): boolean {
    const userRole = this.authSrv.getUser().role.name;
    return userRole === RoleName.admin || userRole === RoleName.super_admin || userRole === RoleName.bizzdev;
  }

  get shouldUseSubcontractorMode(): boolean {
    const userRole = this.authSrv.getUser().role.name;
    if (userRole === RoleName.admin_subcontractor) {
      return true;
    }
    return this.useSubcontractorPrices;
  }

  checkIfColumnsInStorage(): void {
    if (localStorage.getItem('displayedColumnsMenuExportList')) {
      this.displayedColumnsMenuExportList = JSON.parse(localStorage.getItem('displayedColumnsMenuExportList'));
    } else {
      this.displayedColumnsMenuExportList = [
        { editable: false, name: 'select', selected: true, visible: false },
        { editable: true, name: 'identifier', selected: true, visible: false },
        { editable: true, name: 'startDate', selected: true, visible: false },
        { editable: true, name: 'urgency', selected: true, visible: false },
        { editable: true, name: 'sender', selected: true, visible: false },
        { editable: true, name: 'receivers', selected: true, visible: false },
        { editable: true, name: 'status', selected: true, visible: false },
        { editable: true, name: 'client', selected: true, visible: false },
        { editable: true, name: 'site', selected: true, visible: false },
        { editable: true, name: 'createdBy', selected: true, visible: false },
        { editable: true, name: 'createdOn', selected: true, visible: false },
        { editable: true, name: 'driver', selected: true, visible: false },
        { editable: true, name: 'actions', selected: true, visible: false }
      ];
    }
  }

  containsObject(obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].name === obj.name) {
        this.indexToRemove = i;
        return true;
      }
    }

    return false;
  }

  showStatusText(status: OrderStatus): string {
    return 'orders.status.' + OrderStatus[status];
  }

  showTypeText(type: OrderType): string {
    return 'orders.type.' + OrderType[type];
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach(row => this.selection.select(row));
  }

  onFilter(): void {
    this.selection.clear();
    const formValue = this.filterForm.value;

    this.filterValue = formValue;
    this.getList();
  }

  clearFilters(): void {
    this.filterForm.reset();
    this.filterForm.get('status').setValue(16);
    this.filterValue = {
      status: 16
    };
    this.getList();
  }

  filterEnter(event: Event, column) {
    this.filterValue = this.filterForm.value;
    this.getList();
  }

  onPageChanged(pageEvent: PageEvent): void {
    this.selection.clear();
    this.pagination.pageNumber = pageEvent.pageIndex + 1;
    this.getList();
  }

  onSortChanged(sortEvent: Sort): void {
    let direction = '';

    if (sortEvent.direction === 'asc') {
      direction = '';
    } else if (sortEvent.direction === 'desc') {
      direction = '-';
    }
    if (sortEvent.direction === '') {
      this.sortValue = null;
    } else {
      this.sortValue = ` ${direction}${sortEvent.active}`;
    }
    this.getList();
  }

  onExport(): void {
    const idOrders = [];
    this.selection.selected.map(order => {
      idOrders.push(order.id);
    });
    const useSubcontractorMode = this.shouldUseSubcontractorMode;
    this.ordersSrv.exportExcel(idOrders, true, useSubcontractorMode).subscribe(() => {
      this.selection.clear();
    });
  }

  onExportAll(): void {
    const newRequest = new PaginationRequest(
      this.filterValue,
      null,
      null,
      null
    );
    const useSubcontractorMode = this.shouldUseSubcontractorMode;
    this.ordersSrv.exportExcelAll(newRequest, true, true, useSubcontractorMode).subscribe(() => { });
  }

  onSelectOrder(id: string): void {
    this.router.navigate([`orders/${id}`]);
  }

  getList(): void {
    const newRequest = new PaginationRequest(
      this.filterValue,
      this.sortValue,
      this.pagination.pageNumber,
    );

    this.ordersSrv.getList(newRequest, true);
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.orders);
    this.dataSource.sort = this.sort;
  }

  private savePageNumberInSessionStorage(): void {
    if (this.pagination && this.pagination.pageNumber) {
      sessionStorage.setItem('exportListPage', this.pagination.pageNumber.toString());
    }
  }

  private initSubscriptions(): void {
    this.addSubscription(
      this.ordersSrv.ordersListChanged
        .subscribe(orders => {
          this.orders = orders;
          this.setDisplayedColumns();
          this.initTable();
        })
    );


    this.addSubscription(
      this.ordersSrv.paginationSubject
        .subscribe(pagination => {
          if (this.pagination) {
            this.pagination = pagination;
            this.savePageNumberInSessionStorage();
          } else {
            this.pagination = pagination;
          }
        })
    );

    this.filterValue = {
      status: 16
    };

    const page = parseInt(sessionStorage.getItem('exportListPage')) || 1;
    const newRequest = new PaginationRequest(
      this.filterValue,
      this.sortValue,
      page
    );

    this.ordersSrv.getList(newRequest, true, true);

    this.isLoadingFilterForm = true;

    const sitesPromise = new Promise((resolve, reject) => {
      this.sitesSrv.getList()
        .subscribe(sitesFromSrv => {
          this.sites = sitesFromSrv;
          resolve(true);
        });
    });

    const clientsPromise = new Promise((resolve, reject) => {
      this.clientsSrv.getList()
        .subscribe(clientsFromSrv => {
          this.clients = clientsFromSrv;
          resolve(true);
        });
    });

    const urgencyLevelsPromise = new Promise((resolve, reject) => {
      this.dictionarySrv.getUrgencyList()
        .subscribe(urgencyLevelsFromSrv => {
          this.urgencies = urgencyLevelsFromSrv;
          resolve(true);
        });
    });

    const driversPromise = new Promise((resolve, reject) => {
      this.usersSrv.getList()
        .subscribe(driversFromSrv => {
          this.drivers = [...driversFromSrv].filter(oneDriver => oneDriver.role.name !== RoleName.admin_client && oneDriver.role.name !== RoleName.client);
          resolve(true);
        });
    });

    const addressPromise = new Promise((resolve, reject) => {
      this.addressesSrv.getList()
        .subscribe(addressessFromSrv => {
          this.senders = addressessFromSrv.filter(address => address.isSender);
          this.receivers = addressessFromSrv.filter(address => address.isReceiver);
          resolve(true);
        });
    });

    const usersPromise = new Promise((resolve, reject) => {
      this.usersSrv.getList().subscribe((usersFromSrv) => {
        let system = new User('Système', null, null, null, null, null);
        system.id = 'system';
        let all = new User('Tous', null, null, null, null, null);
        all.id = 'all';
        this.users = usersFromSrv;
        this.users.push(system);
        this.users.push(all);
        resolve(true);
      });
    });

    Promise.all([sitesPromise, clientsPromise, urgencyLevelsPromise, addressPromise, driversPromise, usersPromise])
      .then(() => {
        this.isLoadingFilterForm = false;
      });

  }

  changeStatus(status: string, order: Order): void {
    const statusToSend = {
      status: 0,
      comment: null
    };

    let canSend = true;

    if (status === 'receivedByDispatcher') {
      statusToSend.status = 2;
    } else if (status === 'treatedByDispatcher') {
      statusToSend.status = 4;
    } else if (status === 'finished') {
      statusToSend.status = 16;
      canSend = confirm('Etes-vous certain de terminer cette commande ?');
    } else if (status === 'cancelled') {
      statusToSend.status = 32;
      canSend = confirm('Etes-vous certain d\'annuler cette commande ?');
    }

    if (canSend) {
      this.ordersSrv.changeStatus(order.id, statusToSend).subscribe(results => {
        order.status = results.status;
        order.statusChanges = results.statusChanges;
      });
    }
  }

  delete(order: Order): void {
    const confirmation = confirm('Êtes-vous certain de vouloir supprimer cette mission ?');
    if (confirmation) {
      this.ordersSrv.delete(order.id).subscribe(() => {
        this.uiSrv.showSnackbar('Mission supprimée avec succès', false);
      })
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    // Swap the elements around
    moveItemInArray(this.displayedColumnsMenuExportList, event.previousIndex, event.currentIndex);
    localStorage.setItem('displayedColumnsMenuExportList', JSON.stringify(this.displayedColumnsMenuExportList));
    this.setDisplayedColumns();
  }

  onSelectMenu(event, name) {
    this.displayedColumnsMenuExportList.find(f => f.name === name).selected = event.checked;
    localStorage.setItem('displayedColumnsMenuExportList', JSON.stringify(this.displayedColumnsMenuExportList));
    this.setDisplayedColumns();
  }

  private setDisplayedColumns(): void {
    this.displayedColumns = this.displayedColumnsMenuExportList.filter(f => (f || {}).selected).map(m => m.name);
  }

  getControl(control: string): UntypedFormControl {
    return this.filterForm.get(control) as UntypedFormControl;
  }

  generateArticle(orderId) {
    this.isLoading = true;
    this.articlesSrv.generateArticleByOrderId(orderId).subscribe(() => {
      this.isLoading = false;
    })
  }

  onExportStatistics(): void {
    const newRequest = new PaginationRequest(
      this.filterValue,
      null,
      null,
      null
    );
    this.reportsSrv.exportReports(newRequest, true, true).subscribe(() => { });
  }

  onExportPreBilling(): void {
    const newRequest = new PaginationRequest(
      this.filterValue,
      null,
      null,
      null
    );
    const useSubcontractorMode = this.shouldUseSubcontractorMode;
    this.ordersSrv.exportPreBilling(newRequest, useSubcontractorMode).subscribe(() => { });
  }

  isCompleteMonthSelected(): boolean {
    if (!this.filterValue || !this.filterValue.range) {
      return false;
    }

    const fromDate = this.filterValue.range.fromStartDate;
    const toDate = this.filterValue.range.toStartDate;

    if (!fromDate || !toDate) {
      return false;
    }

    const startMoment = moment(fromDate);
    const endMoment = moment(toDate);

    // Check if both dates are in the same month and year
    if (startMoment.month() !== endMoment.month() || startMoment.year() !== endMoment.year()) {
      return false;
    }

    // Check if start date is the first day of the month
    if (startMoment.date() !== 1) {
      return false;
    }

    // Check if end date is the last day of the month
    const lastDayOfMonth = startMoment.clone().endOf('month').date();
    if (endMoment.date() !== lastDayOfMonth) {
      return false;
    }

    return true;
  }

}
